// extracted by mini-css-extract-plugin
export default {"container":"MFGO6","triangleBorder":"ZKa9O","defaultColor":"Lb-90","triangleBackground":"O+v91"};